import { Box, FormControlLabel } from '@mui/material';
import { useEffect, useState } from 'react';
import type { PartnerFacilitiesFilter } from '../../API/services/PartnerFacilityFilterService';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import CustomCheckbox from '@ui-components/CheckBox/CustomCheckBox';

type Props = Readonly<{
  data: PartnerFacilitiesFilter | undefined;
  value?: number[];
  onChange?: (value: number[]) => void;
  isForConsult?: boolean;
}>;

export function StatusFilterSelector({
  data,
  value,
  onChange,
  isForConsult = false,
}: Props) {
  const [selectedStatus, setselectedStatus] = useState<number[]>([]);
  useEffect(() => {
    if (value) {
      setselectedStatus(value);
    }
  }, [value]);

  const handleStatusSelection = (statusId: number, isChecked: boolean) => {
    setselectedStatus((prev) => {
      const updated = isChecked
        ? [...prev, statusId]
        : prev.filter((id) => id !== statusId);
      onChange?.(updated);
      return updated;
    });
  };
  useEffect(() => {}, [selectedStatus]);
  return (
    <Box>
      {isForConsult &&
        data?.consultStatusList.map((status) => {
          return (
            <Box key={status.id}>
              <FormControlLabel
                control={
                  <CustomCheckbox
                    id="status-checkbox"
                    checked={selectedStatus.includes(status.id)}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      console.log(
                        'checked roles id',
                        checked,
                        'role id',
                        status.id
                      );
                      handleStatusSelection(status.id, checked);
                    }}
                  />
                }
                label={
                  <CustomTypography
                    id="partner-name-withCheckbox"
                    variant="body2"
                  >
                    {status.name}
                  </CustomTypography>
                }
              />
            </Box>
          );
        })}
      {!isForConsult &&
        data?.statusList.map((status) => {
          return (
            <Box key={status.id}>
              <FormControlLabel
                control={
                  <CustomCheckbox
                    id="status-check"
                    checked={selectedStatus.includes(status.id)}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      console.log(
                        'checked roles id',
                        checked,
                        'role id',
                        status.id
                      );
                      handleStatusSelection(status.id, checked);
                    }}
                  />
                }
                label={
                  <CustomTypography
                    id="partner-name-withCheckbox"
                    variant="body2"
                  >
                    {status.name}
                  </CustomTypography>
                }
              />
            </Box>
          );
        })}
    </Box>
  );
}
